var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagOpaque(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 1.33333C1.33333 0.965141 1.03486 0.666664 0.666667 0.666664C0.298477 0.666664 0 0.965141 0 1.33333V10.0001C0 10.0001 0 10.0001 0 10.0001V14.6667C0 15.0349 0.298477 15.3333 0.666667 15.3333C1.03486 15.3333 1.33333 15.0349 1.33333 14.6667L1.33333 10.3587C1.3796 10.3358 1.43415 10.311 1.49759 10.2856C1.82701 10.1539 2.40848 10 3.33333 10C4.18713 10 4.90701 10.2808 5.75241 10.619L5.78955 10.6338C6.6022 10.959 7.5377 11.3333 8.66667 11.3333C9.74181 11.3333 10.4937 11.1539 10.9976 10.9523C11.249 10.8518 11.4357 10.7469 11.5677 10.6589C11.6336 10.6149 11.6854 10.5755 11.7246 10.5433C11.7521 10.5206 11.7788 10.4972 11.804 10.4721L11.8047 10.4714C11.9351 10.3411 12.0002 10.1702 12 9.99934V2.66666C12 2.49605 11.9349 2.32543 11.8047 2.19526C11.5493 1.93981 11.1381 1.935 10.8768 2.18084C10.8715 2.1852 10.8557 2.19775 10.8281 2.21613C10.7726 2.25314 10.6677 2.31489 10.5024 2.38101C10.173 2.51278 9.59152 2.66666 8.66667 2.66666C7.81287 2.66666 7.09299 2.38584 6.24759 2.04768L6.21045 2.03282C5.3978 1.70765 4.4623 1.33333 3.33333 1.33333C2.47216 1.33333 1.8184 1.44846 1.33333 1.59787V1.33333Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagOpaque);
export default __webpack_public_path__ + "cdff9a3b110806c4417bc5d9b46123c7.svg";
export { ForwardRef as ReactComponent };